<template>
  <section
    class="quick-actions"
    aria-label="Быстрые действия"
  >
    <header class="quick-actions__header">
      <div class="quick-actions__heading">
        <span class="quick-actions__icon">
          <Zap
            :size="22"
            aria-hidden="true"
          />
        </span>

        <div>
          <h2>Быстрые действия</h2>
          <p>Всё необходимое для работы с продажами и кассой</p>
        </div>
      </div>

      <span
        class="quick-actions__status"
        :class="getActionStatusClass"
      >
        <span/>
        {{ getActionStatusText }}
      </span>
    </header>

    <div class="quick-actions__list">
      <button
        v-if="getOpenedWorkingShift"
        class="quick-actions__action quick-actions__action--blue"
        @click="createSale(null)"
      >
        <span class="quick-actions__action-icon">
          <Plus
            :size="22"
            aria-hidden="true"
          />
        </span>

        <span class="quick-actions__label">
          <strong>Создать продажу</strong>
          <span>Товары и оплата покупки</span>
        </span>

        <ArrowUpRight
          :size="18"
          class="quick-actions__arrow"
          aria-hidden="true"
        />
      </button>

      <button
        v-if="getOpenedWorkingShift"
        class="quick-actions__action"
        @click="createCashOperation"
      >
        <span class="quick-actions__action-icon">
          <Wallet
            :size="22"
            aria-hidden="true"
          />
        </span>

        <span class="quick-actions__label">
          <strong>Операции по кассе</strong>
          <span>Внесение и выдача средств</span>
        </span>

        <ArrowUpRight
          :size="18"
          class="quick-actions__arrow"
          aria-hidden="true"
        />
      </button>

      <button
        class="quick-actions__action quick-actions__action--warning"
        @click="toggleWorkingShift"
      >
        <span class="quick-actions__action-icon">
          <Clock3
            :size="22"
            aria-hidden="true"
          />
        </span>

        <span class="quick-actions__label">
          <strong>{{ getToggleWorkingShiftTextTitle }}</strong>
          <span>{{ getToggleWorkingShiftTextDescription }}</span>
        </span>

        <ArrowUpRight
          :size="18"
          class="quick-actions__arrow"
          aria-hidden="true"
        />
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  Zap,
  Plus,
  Wallet,
  Clock3,
  ArrowUpRight
} from 'lucide-vue'

export default {
  name: 'QuickActions',
  components: {
    Zap,
    Plus,
    Wallet,
    Clock3,
    ArrowUpRight
  },
  inject: {
    pastCodeData: {
      type: Object,
      default: () => ({})
    },
    clearPastCode: {
      type: Function,
      default: () => ({})
    }
  },
  data () {
    return {
      isVisibleModal: false
    }
  },
  computed: {
    ...mapGetters('workingShift', { getOpenedWorkingShift: 'getOpenedWorkingShift' }),
    ...mapGetters('modal', ['getOpenedModals']),
    getActionStatusClass () {
      return { 'quick-actions__status--open': this.getOpenedWorkingShift }
    },
    getActionStatusText () {
      return this.getOpenedWorkingShift ? 'Смена открыта' : 'Смена закрыта'
    },
    getToggleWorkingShiftTextTitle () {
      return this.getOpenedWorkingShift ? 'Закрыть смену' : 'Открыть смену'
    },
    getToggleWorkingShiftTextDescription () {
      return this.getOpenedWorkingShift ? 'Завершение рабочего дня' : 'Начало рабочего дня'
    },
  },
  watch: {
    pastCodeData: {
      deep: true,
      handler ({ pastCodeList = [] } = {}) {
        this.createSale(pastCodeList.at(0))
      }
    }
  },
  methods: {
    ...mapActions('modal', ['openModal', 'closeModal']),
    ...mapActions('workingShift', ['close', 'open']),
    createSale (preSelectedProduct = null) {
      if (this.getOpenedModals.some(({ name }) => name === 'create-sale')) {
        return
      }

      this.openModal({
        name: 'create-sale',
        propsData: {
          preSelectedProduct
        }
      })

      this.clearPastCode()
    },
    createCashOperation () {
      this.openModal({
        name: 'create-base',
        propsData: {
          name: 'cash-operation',
          moduleAction: 'cashOperation',
          type: 'create',
          title: 'Создание кассовой операции',
          text: 'Укажите данные для кассовой операции',
          textCancelBtn: 'Закрыть',
          textConfirmBtn: 'Создать кассовую операцию',
          onClose: () => {
            this.$bus.emit('update-cash-summary')
          }
        }
      })
    },
    toggleWorkingShift () {
      const callback = this.getOpenedWorkingShift
        ? this.close
        : this.open

      const title = this.getOpenedWorkingShift
        ? 'Закрытие рабочей смены'
        : 'Открытие рабочей смены'

      const text = this.getOpenedWorkingShift
        ? 'Укажите сумму в кассе перед закрытием рабочей смены'
        : 'Укажите сумму в кассе перед открытием рабочей смены'

      const textConfirmBtn = this.getOpenedWorkingShift
        ? 'Закрыть рабочую смену'
        : 'Открыть рабочую смену'

      this.openModal({
        name: 'create-base',
        propsData: {
          name: 'working-shift-amount',
          moduleAction: '',
          callback,
          type: 'create',
          title,
          text,
          textCancelBtn: 'Отмена',
          textConfirmBtn,
        }
      })
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
